import {Component, OnInit, ViewChild} from '@angular/core';
import {FeedbackService} from './feedback.service';
import { Localization } from "../common/enums/localization";
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  providers: [FeedbackService]
})
export class FeedbackComponent implements OnInit {

  @ViewChild('modalFeedbackSubmitted') public modalFeedbackSubmitted: ModalDirective;

  public isActionInProgress: boolean;
  public formGroup: UntypedFormGroup;
  public readonly Localization = Localization;

  public get feedbackFormControl() { return this.formGroup.get('feedback'); }

  constructor(private service: FeedbackService) {}

  ngOnInit() {
    this.init();
  }

  public onSubmit() {
    this.isActionInProgress = true;
    this.service.send(this.formGroup.value.feedback).subscribe(
      () => this.onSendSuccess(),
      error => this.onSendError(error)
    );
  }

  private init() {
    this.isActionInProgress = false;
    this.formGroup = new UntypedFormGroup({
      'feedback': new UntypedFormControl(null, [])
    });
  }

  private onSendSuccess() {
    this.isActionInProgress = false;
    this.formGroup.setValue({feedback: null});
    this.modalFeedbackSubmitted.show();
  }

  private onSendError(error: any) {
    this.isActionInProgress = false;
  }
}
